export const messageTypes = {
  info: { id: 0 },
  authorized: { id: 3 },
  rejected: { id: 4 },
  evaluated: { id: 5 }
}
